import React from "react";
import { Link } from "react-router-dom";

const services = [
  {
    icon: "fa-search",
    title: "SEO optimizacija",
    text:
      "SEO optimizacija web stranica za Google: ključne riječi, lokalni SEO Split, tehnički SEO i sadržaj koji diže organski promet i upite.",
  },
  {
    icon: "fa-bullhorn",
    title: "Google Ads i PPC",
    text:
      "Google Ads kampanje, remarketing i PPC oglašavanje s jasnim ciljevima — klikovi, pozivi i prodaja, uz stalnu optimizaciju budžeta.",
  },
  {
    icon: "fa-instagram",
    title: "Društvene mreže",
    text:
      "Vođenje Instagram, Facebook i LinkedIn profila: sadržaj, zajednica i oglasi na društvenim mrežama koji grade prepoznatljivost brenda.",
  },
  {
    icon: "fa-laptop",
    title: "Izrada web stranica",
    text:
      "Izrada modernih, brzih i SEO spremnih web stranica. Jasna poruka, mobilni prikaz i forme koje pretvaraju posjetitelje u klijente.",
  },
  {
    icon: "fa-pencil",
    title: "Content marketing",
    text:
      "Tekstovi, blogovi i vizualni sadržaj usklađeni s ključnim riječima. Content marketing koji obrazuje publiku i jača pozicije na pretraživaču.",
  },
  {
    icon: "fa-line-chart",
    title: "Analitika i strategija",
    text:
      "Mjerenje rezultata, Google Analytics, izvještaji i digitalna strategija. Svaka kampanja ima brojke — i plan što sljedeće poboljšati.",
  },
];

const DigitalniUsluge = ({ showCta = true, showIntro = true }) => {
  return (
    <div className={`intro-area pd-bottom-70 ${showIntro ? "pd-top-80" : "pd-top-50"}`}>
      <div className="container">
        {showIntro && (
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="section-title text-center">
                <h2 className="title">
                  Digitalni marketing <span>koji se mjeri</span>
                </h2>
                <p>
                  SEO optimizacija, Google Ads, vođenje društvenih mreža i
                  izrada web stranica. Online kanal koji radi zajedno s vanjskim
                  oglašavanjem — ista poruka na Googleu, mrežama i na ulici.
                </p>
              </div>
            </div>
          </div>
        )}
        <div className="row">
          {services.map((service) => (
            <div className="col-lg-4 col-md-6" key={service.title}>
              <div className="digital-service-card">
                <div className="digital-icon">
                  <i className={`fa ${service.icon}`} aria-hidden="true" />
                </div>
                <h3>{service.title}</h3>
                <p>{service.text}</p>
              </div>
            </div>
          ))}
        </div>
        {showCta && (
          <div className="row justify-content-center">
            <div className="col-12 text-center">
              <Link className="btn btn-yellow" to="/digitalni-marketing">
                Sve usluge digitalnog marketinga{" "}
                <i className="fa fa-arrow-right" />
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DigitalniUsluge;
